class ProductNameplate extends ProductConfigurator {
  constructor() {
    super();

    this.addEventListener(
      "single-letters:change",
      this.onSingleLettersChanged.bind(this)
    );
  }

  onSingleLettersChanged(ev) {
    this.setSummaryList();
  }

  getVariantSelectOptionForRadios(el) {
    return (
      Array.from(this.variantSelect.options).find(
        (option) => option.text === this.variantTitleFromRadios()
      ) ||
      Array.from(this.variantSelect.options).find((option) =>
        option.text.includes(el.value)
      )
    );
  }
}

customElements.define("product-nameplate", ProductNameplate);

class SingleLetters extends HTMLElement {
  constructor() {
    super();

    this.textField = this.querySelector("input[aria-hidden]");

    this.letterFields = Array.from(
      this.querySelectorAll("input:not([aria-hidden])")
    );

    if (!this.textField) return;

    this.addEventListener(
      "product-configurator:field-restored",
      this.buildHiddenText.bind(this)
    );
    this.addEventListener("keydown", this.onKeyDown.bind(this));
    this.addEventListener("keyup", this.onKeyUp.bind(this));
  }

  buildHiddenText() {
    const prevValue = this.textField.value;
    this.textField.value = this.letterFields
      .map((input) => input.value)
      .join("");

    if (this.textField.value != prevValue) {
      this.dispatchEvent(
        new CustomEvent("single-letters:change", { bubbles: true })
      );
    }
  }

  onKeyDown(ev) {
    const field = ev.target;
    const previousLetterField = field
      .closest("div")
      .previousElementSibling?.querySelector("input");

    if (ev.keyCode == 8) {
      ev.preventDefault();
      if (field.value == "") {
        previousLetterField?.select();
      } else {
        field.value = "";
      }
    }
  }

  onKeyUp(ev) {
    const field = ev.target;
    const nextLetterField = field
      .closest("div")
      .nextElementSibling?.querySelector("input");

    if (ev.keyCode == 8 || ev.keyCode == 9 || ev.keyCode == 16) return;

    field.value = field.value.toUpperCase();
    if (field.validity.valid) {
      nextLetterField?.select();
    }

    this.buildHiddenText();
  }
}

customElements.define("single-letters", SingleLetters);
